var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.75072 539.4944m-472.18176 0a472.18176 472.18176 0 1 0 944.36352 0 472.18176 472.18176 0 1 0-944.36352 0Z",
    fill: "#FF7100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M508.78976 219.22816c-20.6848-44.63616 19.46624-107.20256 89.68704-139.74528 70.21568-32.54272 143.90784-22.7328 164.59776 21.90336L508.78976 219.22816z",
    fill: "#30C03F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M508.78976 219.22816c20.6848 44.63616 94.37696 54.44608 164.59776 21.90336 70.21568-32.54272 110.37184-95.104 89.68704-139.74528L508.78976 219.22816z",
    fill: "#97CF43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M370.32448 220.49792m-23.6544 0a23.6544 23.6544 0 1 0 47.3088 0 23.6544 23.6544 0 1 0-47.3088 0Z",
    fill: "#FFA05F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.208 313.6768m-23.6544 0a23.6544 23.6544 0 1 0 47.3088 0 23.6544 23.6544 0 1 0-47.3088 0Z",
    fill: "#FFA05F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M743.41376 281.06752m-23.6544 0a23.6544 23.6544 0 1 0 47.3088 0 23.6544 23.6544 0 1 0-47.3088 0Z",
    fill: "#FFA05F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M859.53024 388.224m-23.6544 0a23.6544 23.6544 0 1 0 47.3088 0 23.6544 23.6544 0 1 0-47.3088 0Z",
    fill: "#FFA05F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M767.06816 434.816m-23.6544 0a23.6544 23.6544 0 1 0 47.3088 0 23.6544 23.6544 0 1 0-47.3088 0Z",
    fill: "#FFA05F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M631.59296 346.65472m-23.6544 0a23.6544 23.6544 0 1 0 47.3088 0 23.6544 23.6544 0 1 0-47.3088 0Z",
    fill: "#FFA05F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M878.16704 565.26848m-23.6544 0a23.6544 23.6544 0 1 0 47.3088 0 23.6544 23.6544 0 1 0-47.3088 0Z",
    fill: "#FFA05F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M504.02304 224.35328s-27.4944-173.22496-8.24832-192.47104 33.90976-12.17024 41.24672-5.49888c15.12448 13.7472-16.49664 159.47776-16.49664 178.72384 0 19.24608-8.24832 38.49216-16.50176 19.24608z",
    fill: "#5A4530"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M460.36992 221.66016s33.19808-5.24288 54.16448 0c20.9664 5.24288 22.71232 6.9888 26.20928 12.23168 3.49184 5.24288-24.45824 3.49184-24.45824 3.49184s-19.22048-5.24288-31.44704-5.24288H463.872s-13.98272-5.23776-3.50208-10.48064z",
    fill: "#5A4530"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bdcfe3dddbeab2c99376bc2abd31d1eb.svg";
export { ForwardRef as ReactComponent };